enum NotificationsTypes {
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
  Information = 'info',
  None = 'none'
}

export default NotificationsTypes;
